import React from 'react';
import { cn } from './cn';

function Badge({ className, variant = 'secondary', ...props }) {
  return <span className={cn('ui-badge', `ui-badge--${variant}`, className)} {...props} />;
}

export { Badge };
